var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgType(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.96842 9.5225L9.6 2L14.2316 9.5225H4.96842ZM14.3368 19C13.2982 19 12.4281 18.6458 11.7263 17.9375C11.0246 17.2292 10.6737 16.3508 10.6737 15.3025C10.6737 14.2542 11.0246 13.3758 11.7263 12.6675C12.4281 11.9592 13.2982 11.605 14.3368 11.605C15.3754 11.605 16.2456 11.9592 16.9474 12.6675C17.6491 13.3758 18 14.2542 18 15.3025C18 16.3508 17.6491 17.2292 16.9474 17.9375C16.2456 18.6458 15.3754 19 14.3368 19ZM2 18.4688V12.0088H8.4V18.4688H2ZM14.3386 17.725C15.0111 17.725 15.5789 17.4906 16.0421 17.0219C16.5053 16.5533 16.7368 15.9795 16.7368 15.3007C16.7368 14.6219 16.5047 14.0488 16.0403 13.5813C15.576 13.1138 15.0076 12.88 14.3351 12.88C13.6626 12.88 13.0947 13.1144 12.6316 13.5831C12.1684 14.0517 11.9368 14.6255 11.9368 15.3043C11.9368 15.9831 12.169 16.5563 12.6333 17.0238C13.0977 17.4913 13.6661 17.725 14.3386 17.725ZM3.26316 17.1938H7.13684V13.2838H3.26316V17.1938ZM7.24211 8.2475H11.9579L9.6 4.40125L7.24211 8.2475Z",
    fill: "#344054"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgType);
export default __webpack_public_path__ + "static/media/type.81aafd72658ea65cea4b9afac0cc0259.svg";
export { ForwardRef as ReactComponent };